export default __webpack_public_path__ + "static/media/karavan-social-networking-app-screen-2.f43cb027.png";